module.exports = __webpack_public_path__ + "img/card_informe_proceso_registro.170733bb.svg";